import { render } from "./ConfirmationPopup.vue?vue&type=template&id=4913a22e&scoped=true"
import script from "./ConfirmationPopup.vue?vue&type=script&lang=js"
export * from "./ConfirmationPopup.vue?vue&type=script&lang=js"

import "./ConfirmationPopup.vue?vue&type=style&index=0&id=4913a22e&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4913a22e"]])

export default __exports__